import { Flex } from '@ui-library/misc';
import Svg from '@svg/index';
import { Select } from 'antd';
import Tooltip from '@ui-library/tooltip';
import * as React from 'react';
import styled from 'styled-components';
import { is } from 'typescript-styled-is';
import { IColumn } from '@components/sources/source/warehouseSource/configureData/sourceSpecificConfig';
import { IField, useConnectionState } from '../../../visualDataMappingProvider';
import classes from '../mapping-commons.module.scss';
import ErrorLabel from '@ui-library/errorLabel';

const TextDiv = styled.span`
  ${is('hasError')`
    color:#EB0000!important;
  `}
`;
export const TableSelect = styled(Select)`
  width: 100%;

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  }
  .ant-select-selector {
    height: 48px !important;
    align-items: center !important;
    outline: none !important;
    box-shadow: unset !important;
    padding-left: 10px !important;
    padding-right: 0 !important;
    border-radius: 4px !important;
    ${is('hasError')`
    border: 1px solid #EB0000!important;
    color:#EB0000!important;
    `}
  }
  .ant-select-selection-search {
    color: #4a4a4a;
    line-height: 1.5;
    align-items: center;
    display: flex;
  }
  .ant-select-selection-item {
    display: flex;
  }
  .ant-select-arrow .anticon:not(.ant-select-suffix) {
    pointer-events: none !important;
  }
`;

interface Props {
  column: IColumn & { unidentified?: string; label?: string };
}

const ColumnView = ({ column }: Props) => (
  <Flex className={classes.column_view}>
    <TextDiv className={classes.column_data} hasError={column?.unidentified}>
      <Tooltip placement="left" title={column?.label || column?.name}>
        {column?.label || column?.name}
      </Tooltip>
    </TextDiv>
    <TextDiv className={classes.column_data_type} hasError={column?.unidentified}>
      {column?.type}
    </TextDiv>
  </Flex>
);
const FieldView = ({
  field,
  onClick,
  columnsSide,
}: {
  field: IField & { unidentified?: boolean };
  onClick?: (field: IField) => void;
  columnsSide?: boolean;
}) => {
  if (!field?.name) {
    return null;
  }

  return (
    <Flex
      className={`${classes.field_view} ${columnsSide ? classes.columns_side : ''}`}
      onClick={() => {
        if (onClick) {
          onClick(field);
        }
      }}
    >
      <TextDiv className={classes.field_data} hasError={field.unidentified}>
        <Tooltip placement="left" title={field?.label || field?.name}>
          {field?.label || field?.name}
        </Tooltip>
      </TextDiv>
      <TextDiv className={classes.field_data_type} hasError={field.unidentified}>
        {field?.type}
      </TextDiv>
    </Flex>
  );
};

const PreviewView = ({ column }: { column?: string }) => {
  const { preview, enteredSaveState } = useConnectionState();
  const errorState = (column || enteredSaveState) && !preview[column || '']?.toString();

  let errorMsg = '';
  if (column) {
    errorMsg = 'Column not found';
  } else if (enteredSaveState) {
    errorMsg = 'Select a column';
  }

  const previewData =
    preview && Object.keys(preview).length > 0 && preview[column || '']?.toString();
  return (
    <Flex flexDirection="row" className={classes.preview_view}>
      {previewData ? (
        <Tooltip placement="topLeft" title={preview[column || '']?.toString()}>
          <TextDiv className={classes.preview_data} hasError={errorState}>
            {previewData}
          </TextDiv>
        </Tooltip>
      ) : (
        <div className="full-width">
          <ErrorLabel error={Boolean(errorMsg)} errorMessage={errorMsg} />
        </div>
      )}
      <Svg
        fill="#2E3A59"
        height={12}
        width={16}
        className={`${classes.mapping_arraw_icon} ${classes.preview_arrow}`}
        name="right-arrow"
      />
    </Flex>
  );
};

export { PreviewView, FieldView, ColumnView };
